/* eslint-disable import/prefer-default-export */
import SectionLayout from './SectionLayout/SectionLayout'

export const SectionContainer = SectionLayout
